module.exports={
	"Form": "TestSpecificationCreateManifest",
	"Scope": "TestSpecification-Create",
	"Descriptors":
	{
		"TestSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecification-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecification-Create-Identity",
				"Group": "TestSpecification-Create-Identity"
			}
		},
		"TestSpecificationDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "TestSpecification-Create-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecification-Create-Details",
				"Group": "TestSpecification-Create-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				]
			}
		},
		"TestSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "TestSpecification-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "TestSpecification-Create-Details",
				"Group": "TestSpecification-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecification-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecification-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecification-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecification-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
